import { render } from "./VSessionManager.vue?vue&type=template&id=6db20ff6"
import script from "./VSessionManager.vue?vue&type=script&lang=js"
export * from "./VSessionManager.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__